import React from "react";
import styled from "styled-components";
import EmailIcon from "./icons/EmailIcon";
import PhoneIcon from "./icons/PhoneIcon";
import FacebookIcon from "./icons/FacebookIcon";
import InstagramIcon from "./icons/InstagramIcon";
import CommunityIcon from "./icons/CommunityIcon";
import SnapchatIcon from "./icons/SnapchatIcon";
import TikTokIcon from "./icons/TikTokIcon";
import YoutubeIcon from "./icons/YoutubeIcon";
import TwitterIcon from "./icons/TwitterIcon";
import PinterestIcon from "./icons/PinterestIcon";

const InbioSocialChannelsContainer = styled("div")`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    gap: 16px;
  `;

  const InbioSocialChannelsItem = styled("div")`
    cursor: pointer;
    &:hover svg {
      fill: #111111;
    }
    &:hover svg circle {
      stroke: #111111;
    }
    &:hover svg path {
      stroke: #ffffff;
    }
    &:active svg {
      fill: #111111;
    }
    &:active svg circle {
      stroke: #111111;
    }
    &:active svg path {
      stroke: #ffffff;
    }
  `;

  const InbioSocialChannelsStyledItem = styled("div")`
    cursor: pointer;
    &:hover {
      fill: #111111;
    }
    &:hover circle {
      stroke: #111111;
      fill: #111111;
    }
    &:hover path {
      fill: #fff;
    }
    &:active {
      fill: #111111;
    }
    &:active circle {
      stroke: #111111;
      fill: #111111;
    }
    &:active path {
      fill: #fff;
    }
  `;

export default function InbioSocialChannelsContent({ content, getIpAndPublishToSns }) {
  function getInbioSocialChannelsItem(content) {
    let socialChannels = [];

    return (
      <InbioSocialChannelsContainer>
        {Object.entries(content.social_channels).forEach(([key, value]) => {
          if (key === "phone" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel Phone",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`tel:${value.value}`)
                }
              }>
                <PhoneIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "email" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                key={key} 
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel Mail",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`mailto:${value.value}`)
                }
              }>
                <EmailIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "facebook" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel FB",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`https://facebook.com/${value.value}`, "_blank")
                }}
              >
                <FacebookIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "instagram" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel IG",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`https://instagram.com/${value.value}`, "_blank")
                }}
              >
                <InstagramIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "community" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel Community",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(
                    `https://my.community.com/${value.value}`,
                    "_blank"
                  )
                }}
              >
                <CommunityIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "snapchat" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsStyledItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel SnapChat",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(
                    `https://story.snapchat.com/@${value.value}`,
                    "_blank"
                  )
                }}
              >
                <SnapchatIcon />
              </InbioSocialChannelsStyledItem>
            );
          }
          if (key === "tiktok" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsStyledItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel TikTok",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`https://tiktok.com/@${value.value}`, "_blank")
                }}
              >
                <TikTokIcon />
              </InbioSocialChannelsStyledItem>
            );
          }
          if (key === "youtube" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                key={key}
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel YT",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(value.value, "_blank")
                }}
              >
                <YoutubeIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "twitter" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel Twitter",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`https://twitter.com/${value.value}`, "_blank")
                }}
              >
                <TwitterIcon />
              </InbioSocialChannelsItem>
            );
          }
          if (key === "pinterest" && value.active) {
            socialChannels.push(
              <InbioSocialChannelsItem
                onClick={() => {
                  getIpAndPublishToSns({
                    payload: {
                      actor_type: "InbioCustomer",
                      category: "SocialChannel Pinterest",
                      action: "clicked",
                      label: value.value,
                      value: content.id,
                      page: window.location.href
                    },
                    topic: "product_usage_stats",
                  });
                  window.open(`https://pinterest.com/${value.value}`, "_blank")
                }}
              >
                <PinterestIcon />
              </InbioSocialChannelsItem>
            );
          }
        })}
        {socialChannels.map((channel) => channel)}
      </InbioSocialChannelsContainer>
    );
  }

  return getInbioSocialChannelsItem(content);
}
